<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="standardpage tiles">
      <b-card-header>
        <i :class="icon" class="mr-1"></i>
        <!-- <CIcon :name="icon" /> -->
        {{ title }}
        <div class="card-header-actions">
          <b-button size="sm" variant="outline-primary" class="card-header-action mr-1" @click="layout_refresh()"
            :disabled="layout_edit">
            <i class="fa fa-refresh"></i>
          </b-button>

          <b-button size="sm" variant="outline-primary" class="card-header-action" :disabled="layout_edit"
            v-b-toggle.addtile>
            <i class="fa fa-plus-square"></i>
          </b-button>
        </div>
      </b-card-header>

      <b-card-body class="px-0">
        <b-row class="px-3">
          <b-col>
            <div id="refresh">
              <div v-if="window.width > 768">
                <span class="mr-2">Auto refresh:</span>
                <b-button v-if="refresh_at > 0" id="refresh_popover-id" size="sm" variant="outline-primary" ref="button"
                  style="width: 100px">{{ refresh_at }} minute(s)</b-button>
                <b-button v-if="refresh_at == 0" id="refresh_popover-id" size="sm" variant="outline-primary"
                  ref="button" class="ml-2" style="width: 100px">Off</b-button>
              </div>
              <div v-else>
                <b-row>
                  <b-col cols="12" md="6">Auto refresh:</b-col>
                  <b-col>
                    <b-button v-if="refresh_at > 0" id="refresh_popover-id" size="sm" variant="outline-primary"
                      ref="button" style="width: 100px">{{ refresh_at }} minute(s)</b-button>
                    <b-button v-if="refresh_at == 0" id="refresh_popover-id" size="sm" variant="outline-primary"
                      ref="button" class="ml-2" style="width: 100px">Off</b-button>
                  </b-col>
                </b-row>
              </div>
            </div>
            <b-popover target="refresh_popover-id" :show.sync="refresh_popover" triggers="click" placement="bottom"
              container="refresh" ref="popover">
              <div>
                <b-form-radio-group class="mt-2 mb-2" name="Auto Refresh Every" v-model="refresh_at" :options="[
                  { text: 'Off', value: 0 },
                  { text: '1 min', value: 1 },
                  { text: '5 min', value: 5 },
                  { text: '10 min', value: 10 },
                ]" stacked></b-form-radio-group>

                <b-button @click="refresh_popover = false" size="sm" variant="outline-primary"
                  class="ml-2">OK</b-button>
              </div>
            </b-popover>
          </b-col>
          <b-col align-self="end" class="text-right">
            <div v-if="window.width > 768">
              <span class="mr-2">Last updated:</span>
              <span class="text-primary" v-text="refresh_timeago ? refresh_timeago : 'Off'"></span>
            </div>
            <div v-else>
              <b-row>
                <b-col class="text-right" cols="12" md="6">Last updated:</b-col>
                <b-col>
                  <span class="text-primary" v-text="refresh_timeago ? refresh_timeago : 'Off'"></span>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row class="px-3 mt-4">
          <b-button-group class="ml-3 z-2">
            <b-row no-gutters>
              <b-col cols="auto">
                <b-button squared size="sm" :title="title + ' tiles'" :variant="toolbar_variant"
                  :pressed="selectedComponent == null" @click="selectedComponent = null"><i
                    class="fa fa-home pr-3"></i>Home</b-button></b-col>

              <b-col cols="auto">
                <b-dropdown size="sm" left :variant="toolbar_variant">
                  <template slot="button-content">
                    <i class="fa fa-briefcase mr-1"></i>
                    Business
                  </template>

                  <b-dropdown-item>
                    <span class="text-primary">Activity</span>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Events'"
                      @click="selectedComponent = 'Events'"><i
                        class="fa fa-calendar-check-o"></i>Events</b-dropdown-item>

                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'InventoryLines'"
                      @click="selectedComponent = 'InventoryLines'"><i
                        class="fa fa-puzzle-piece"></i>Charges</b-dropdown-item>

                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Bookings'"
                      @click="selectedComponent = 'Bookings'"><i class="fa fa-globe"></i>Bookings
                      (GDS)</b-dropdown-item>

                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'TicketsRepository'"
                      @click="selectedComponent = 'TicketsRepository'"><i class="fa fa-ticket"></i>Tickets
                    </b-dropdown-item>
                  </b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item>
                    <span class="text-primary">Clients</span>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'SLStatements2' ? true : false"
                      @click="selectedComponent = 'SLStatements2'">
                      <i class="fa fa-list-alt"></i>Statements</b-dropdown-item>

                    <!-- <b-dropdown-item v-if="user.department.toLowerCase() == 'development'" class="menuitem" :pressed="selectedComponent == 'SLStatements' ? true : false"
                      @click="selectedComponent = 'SLStatements'">
                      <i class="fa fa-gbp"></i>Statements0LD</b-dropdown-item> -->
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Orders' ? true : false"
                      @click="selectedComponent = 'Orders'">
                      <i class="fa fa-gavel"></i>Orders</b-dropdown-item>

                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'SLPayments'"
                      @click="selectedComponent = 'SLPayments'"><i class="fa fa-money"></i>Payments</b-dropdown-item>

                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'SLTransactions2'"
                      @click="selectedComponent = 'SLTransactions2'"><i class="fa fa-wpforms"></i>Sales ( Invoices
                      )</b-dropdown-item>

                    <b-dropdown-item v-if="permissionvalid('systems.development') || user.inititals == 'MR'"
                      class="menuitem" :pressed="selectedComponent == 'SLTransactionsN'"
                      @click="selectedComponent = 'SLTransactionsN'"><i class="fa fa-wpforms"></i>Sales ( SQL )
                    </b-dropdown-item>

                  </b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item>
                    <span class="text-primary">Suppliers</span>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'BLTransactions2'"
                      @click="selectedComponent = 'BLTransactions2'"><i class="fa fa-pie-chart"></i>Costs
                    </b-dropdown-item>

                    <b-dropdown-item v-if="permissionvalid('systems.development') || user.inititals == 'MR'"
                      class="menuitem" :pressed="selectedComponent == 'BLTransactionsN'"
                      @click="selectedComponent = 'BLTransactionsN'"><i class="fa fa-pie-chart"></i>Costs ( SQL )
                    </b-dropdown-item>

                  </b-dropdown-item>



                </b-dropdown>
              </b-col>

              <b-col cols="auto">
                <b-dropdown size="sm" left :variant="toolbar_variant">
                  <template slot="button-content">
                    <i class="fa fa fa-line-chart mr-1"></i>
                    Accounting
                  </template>
                  <b-dropdown-item>
                    <span class="text-primary">Banking</span>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Bankings' ? true : false
                      " @click="selectedComponent = 'Bankings'">
                      <i class="fa fa-university"></i>
                      Bank Feeds
                    </b-dropdown-item>
                  </b-dropdown-item>

                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item>
                    <span class="text-primary">General</span>

                    <b-dropdown-item class="menuitem" v-if="permissionvalid('setup.nlcodes')"
                      :pressed="selectedComponent == 'NLCodes'" @click="selectedComponent = 'NLCodes'"><i
                        class="fa fa-list"></i>Chart
                      of Accounts</b-dropdown-item>

                    <b-dropdown-item class="menuitem" v-if="permissionvalid('setup.openingbalances')"
                      :pressed="selectedComponent == 'OpeningBalancesPG'"
                      @click="selectedComponent = 'OpeningBalancesPG'"><i class="fa fa-play"></i>Opening
                      Balances</b-dropdown-item>
                    <!-- <b-dropdown-item class="menuitem" v-if="permissionvalid('setup.openingbalances')"
                      :pressed="selectedComponent == 'OpeningBalances2'"
                      @click="selectedComponent = 'OpeningBalances2'"><i class="fa fa-play"></i>Opening
                      Balances (New)</b-dropdown-item> -->
                    <b-dropdown-item class="menuitem" v-if="permissionvalid('setup.openingbalances')"
                      :pressed="selectedComponent == 'OpeningBalances3'"
                      @click="selectedComponent = 'OpeningBalances3'"><i class="fa fa-play"></i>Opening
                      Balances ( e-table )</b-dropdown-item>

                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'NLTransactions2'"
                      @click="selectedComponent = 'NLTransactions2'"><i class="fa fa-balance-scale"></i>Nominal
                      Ledger</b-dropdown-item>

                    <b-dropdown-item v-if="permissionvalid('systems.development') || user.inititals == 'MR'"
                      class="menuitem" :pressed="selectedComponent == 'NLTransactionsN'"
                      @click="selectedComponent = 'NLTransactionsN'"><i class="fa fa-balance-scale"></i>Nominal Ledger
                      ( SQL )
                    </b-dropdown-item>

                    <b-dropdown-item class="menuitem" v-if="permissionvalid('journals.view')"
                      :pressed="selectedComponent == 'Journals'" @click=" selectedComponent = 'Journals'"><i
                        class=" fa fa-pencil-square-o"></i>Journals
                    </b-dropdown-item>
                    <!-- <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'JournalEntries'"
                      @click="selectedComponent = 'JournalEntries'"><i class="fa fa-pencil-square-o"></i>Journal Entries
                     </b-dropdown-item> -->
                    <b-dropdown-item class="menuitem" v-if="permissionvalid('nominalledger.trialbalance')"
                      :pressed="selectedComponent == 'Report'" @click="runreport(
                        {
                          label: 'Trial Balance',
                          id: 'report_nltrial',
                        },
                        'Report1'
                      )
                        "><i class="fa fa-leanpub"></i>Trial Balance</b-dropdown-item>

                  </b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item>
                    <span class="text-primary">Control</span>

                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Periodend'"
                      @click="selectedComponent = 'Periodend'"><i class="fa fa-list-ol"></i>Active
                      Period/Counters</b-dropdown-item>

                    <b-dropdown-item
                      v-if="user.department.toLowerCase() == 'development' || user.department.toLowerCase() == 'accounts'"
                      class="menuitem" :pressed="selectedComponent == 'InvoicingOnOff'"
                      @click="selectedComponent = 'InvoicingOnOff'">
                      <i class="fa fa-toggle-on"></i>Invoicing On/Off
                    </b-dropdown-item>

                    <!-- <b-dropdown-item class="menuitem" @click="this.toggle_invoicingstate">
                      <i class="fa fa-toggle-on"></i>Invoicing On/Off
                    </b-dropdown-item> -->

                  </b-dropdown-item>

                  <!-- <b-dropdown-divider></b-dropdown-divider> -->
                  <!-- <b-dropdown-item>
                    <span class="text-primary">Chart of Accounts</span>

                  </b-dropdown-item> -->
                  <!-- <b-dropdown-item>
                    <span class="text-primary">Setup</span>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'AllCodes'"
                      @click="selectedComponent = 'AllCodes'"><i class="fa fa-list"></i>All Codes</b-dropdown-item>

                  </b-dropdown-item> -->

                </b-dropdown>
              </b-col>
              <b-col cols="auto">
                <b-dropdown size="sm" left :variant="toolbar_variant">
                  <template slot="button-content">
                    <i class="fa fa-bullhorn mr-1"></i>
                    Contacts
                  </template>

                  <b-dropdown-item class="menuitem" v-if="permissionvalid('clients.view')"
                    :pressed="selectedComponent == 'Clients'" @click="selectedComponent = 'Clients'">
                    <i class="fa fa-handshake-o pr-3"></i>
                    Clients
                  </b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item class="menuitem" v-if="permissionvalid('suppliers.view')"
                    :pressed="selectedComponent == 'Suppliers'" @click="selectedComponent = 'Suppliers'">
                    <i class="fa fa-industry"></i>
                    Suppliers</b-dropdown-item>
                </b-dropdown>
              </b-col>

              <b-col cols="auto">
                <b-dropdown size="sm" left :variant="toolbar_variant">
                  <template slot="button-content">
                    <i class="fa fa-cogs mr-1"></i>
                    Setup
                  </template>

                  <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'AllCodes'"
                    @click="selectedComponent = 'AllCodes'"><i class="fa fa-list"></i>All Codes</b-dropdown-item>
                  <!-- <b-dropdown-divider></b-dropdown-divider> -->

                </b-dropdown>
              </b-col>

              <b-col cols="auto">
                <b-dropdown size="sm" left :variant="toolbar_variant">
                  <template slot="button-content">
                    <i class="fa fa-leanpub mr-1"></i>
                    Reports
                  </template>
                  <!-- <b-dropdown-item>
                    <span class="text-primary">Reports</span>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'AllAccountsReports'"
                      @click="selectedComponent = 'AllAccountsReports'"><i class="fa fa-leanpub"></i>All
                      Reports</b-dropdown-item>
                  </b-dropdown-item> -->

                  <b-dropdown-item>
                    <span class="text-primary">Accounts</span>

                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport({
                      label: 'Bankings Statement',
                      id: 'report_bankings',
                    },
                      'Report1')
                      "><i class="fa fa-leanpub mr-1"></i>Bankings Statement
                    </b-dropdown-item>

                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport({
                      label: 'Statement Matching',
                      id: 'report_statementmatching',
                    },
                      'Report1')
                      "><i class="fa fa-leanpub mr-1"></i>Statement Matching
                    </b-dropdown-item>
                    <!-- <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport({
                      label: 'Clients',
                      id: 'report_clientslisting',
                    },
                      'Report1')
                      "><i class="fa fa-leanpub mr-1"></i>Clients</b-dropdown-item>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport({
                      label: 'Events',
                      id: 'report_eventslisting',
                    },
                      'Report1')
                      "><i class="fa fa-leanpub mr-1"></i>Events</b-dropdown-item>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport({
                      label: 'Suppliers',
                      id: 'report_supplierslisting',
                    },
                      'Report1')
                      "><i class="fa fa-leanpub mr-1"></i>Suppliers</b-dropdown-item>-->
                  </b-dropdown-item>

                  <b-dropdown-item>
                    <span class="text-primary">Clients Invoice</span>
                    <!-- <b-dropdown-item
                      class="menuitem"
                      :pressed="selectedComponent == 'Report'"
                      @click="
                        runreport({
                          label: 'BBC Agency Spend',
                          id: 'report_bbcagencyspend',
                        })
                      "
                      ><i class="fa fa-leanpub mr-1"></i>BBC Agency
                      Spend</b-dropdown-item
                    > -->
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport(
                      {
                        label: 'Clients Invoice Summary',
                        id: 'report_invoicesummary',
                      },
                      'Report1'
                    )
                      "><i class="fa fa-leanpub mr-1"></i>
                      Summary</b-dropdown-item>

                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport(
                      {
                        label: 'Clients Invoice Apportion',
                        id: 'report_invoiceapportion',
                      },
                      'Report1'
                    )
                      "><i class="fa fa-leanpub mr-1"></i>
                      Apportion</b-dropdown-item>
                  </b-dropdown-item>
                  <!-- 
                  <b-dropdown-item>
                    <span class="text-primary">Ledgers</span>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport({
                      label: 'Costs',
                      id: 'report_boughtledger',
                    }, 'Report1')
                      "><i class="fa fa-leanpub"></i>Costs
                    </b-dropdown-item>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport({
                      label: 'Sales',
                      id: 'report_salesledger',
                    }, 'Report1')

                      "><i class="fa fa-leanpub"></i>Sales</b-dropdown-item>
                        <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport({
                      label: 'Nominal',
                      id: 'report_nominalledger',
                    }, 'Report1')

                      "><i class="fa fa-leanpub"></i>Nominal</b-dropdown-item>

                  </b-dropdown-item> -->

                  <b-dropdown-item>
                    <span class="text-primary">Tickets</span>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport({
                      label: 'Tickets',
                      id: 'report_ticketsrepository',
                    }, 'Report1')
                      "><i class="fa fa-leanpub"></i>Tickets
                    </b-dropdown-item>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport({
                      label: 'Tickets Not Invoiced',
                      id: 'report_ticketsnotinvoiced',
                    }, 'Report1')

                      "><i class="fa fa-leanpub"></i>Tickets Not
                      Invoiced</b-dropdown-item>

                  </b-dropdown-item>

                </b-dropdown>
              </b-col>
              <b-col cols="auto">
                <b-dropdown size="sm" left :variant="toolbar_variant">
                  <template slot="button-content">
                    <i class="fa fa-external-link mr-1"></i>
                    Exports
                  </template>

                  <b-dropdown-item>
                    <span class="text-primary">AMEX GBT</span>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport(
                      {
                        label: 'AMEX GBT Compliance Active SL',
                        id: 'report_amexaccountsactivesl',
                      },
                      'Report1'
                    )
                      "><i class="fa fa-leanpub mr-1"></i>Compliance Active SL
                    </b-dropdown-item>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport(
                      {
                        label: 'AMEX GBT Compliance Active BL',
                        id: 'report_amexaccountsactivebl',
                      },
                      'Report1'
                    )
                      "><i class="fa fa-leanpub mr-1"></i>Compliance Active BL
                    </b-dropdown-item>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport(
                      {
                        label: 'AMEX GBT Data Warehouse',
                        id: 'report_amexgbtdatawarehouse',
                      },
                      'Report1'
                    )
                      "><i class="fa fa-leanpub mr-1"></i>Data Warehouse
                    </b-dropdown-item>



                  </b-dropdown-item>

                  <b-dropdown-item>
                    <span class="text-primary">BBC</span>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport(
                      {
                        label: 'BBC Agency Spend',
                        id: 'report_bbcagencyspend',
                      },
                      'Report1'
                    )
                      "><i class="fa fa-leanpub mr-1"></i>Agency Spend
                    </b-dropdown-item>
                  </b-dropdown-item>

                  <b-dropdown-item>
                    <span class="text-primary">REDBULL</span>

                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport(
                      {
                        label: 'Red Bull Marketing',
                        id: 'report_redbullmarketing',
                      },
                      'Report1'
                    )
                      "><i class="fa fa-leanpub mr-1"></i>Red Bull Marketing
                    </b-dropdown-item>

                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport(
                      {
                        label: 'AMEX GBT Red Bull Data Request',
                        id: 'report_amexgbtcarbon',
                      },
                      'Report1'
                    )
                      "><i class="fa fa-leanpub mr-1"></i>Red Bull Data Request
                    </b-dropdown-item>
                  </b-dropdown-item>

                  <b-dropdown-item>
                    <span class="text-primary">SABRE</span>

                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="runreport(
                      {
                        label: 'PRISM',
                        id: 'report_sabreprism',
                      },
                      'Report1'
                    )
                      "><i class="fa fa-leanpub mr-1"></i>PRISM
                    </b-dropdown-item>
                  </b-dropdown-item>

                  <b-dropdown-item>
                    <span class="text-primary">FEEDS</span>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="
                      runreport(
                        {
                          label: 'ANVIL PNR',
                          id: 'report_anvil',
                        },
                        'Report1'
                      )
                      "><i class="fa fa-leanpub"></i>ANVIL PNR
                    </b-dropdown-item>
                    <b-dropdown-item class="menuitem" :pressed="selectedComponent == 'Report'" @click="
                      runreport(
                        {
                          label: 'ISOS',
                          id: 'report_isos',
                        },
                        'Report1'
                      )
                      "><i class="fa fa-leanpub"></i>ISOS
                    </b-dropdown-item>
                  </b-dropdown-item>
                </b-dropdown>

              </b-col>
              <b-col cols="auto">
                <b-dropdown size="sm" left :variant="toolbar_variant">
                  <template slot="button-content">
                    <i class="fa fa-wrench mr-1"></i>
                    Tools
                  </template>
                  <!-- <b-dropdown-item
                    variant="primary"
                    class="menuitem"
                    v-if="permissionvalid('queue.view')"
                    :active="selectedComponent == 'Queue' ? true : false"
                    @click="selectedComponent = 'Queue'"
                    ><i class="fa fa-stack-overflow"></i>Z-hold Queue
                    </b-dropdown-item
                  > -->

                  <b-dropdown-item variant="primary" class="menuitem" v-if="permissionvalid('tool.filemanager')"
                    :active="selectedComponent == 'FileManager' ? true : false"
                    @click="selectedComponent = 'FileManager'"><i class="fa fa-sitemap"></i>Server File
                    Manager</b-dropdown-item>

                  <b-dropdown-item variant="primary" class="menuitem"
                    :active="selectedComponent == 'WFH' ? true : false" @click="selectedComponent = 'WFH'"><i
                      class="fa fa-laptop"></i>Working From Home</b-dropdown-item>

                </b-dropdown>
              </b-col>

            </b-row>

          </b-button-group>
        </b-row>
        <div v-if="selectedComponent == null" class="dashboard_layout mt-4 ml-2">
          <b-row no-gutters :style="layout_edit ? 'background-color:rgba(225, 225, 225, 0.1)' : ''
            ">
            <b-col :cols="item.cols" :md="item.md" :lg="item.lg" v-for="(item, index) in layout_grid" :key="index"
              no-body class="pr-3">
              <b-card class="ml-0  border-none" no-body :border-variant="tile_selected == index ? 'secondary' : null"
                style="border-radius: 0" @mouseover="!tile_settings ? (tile_selected = index) : null">
                <div class="popover-actions z-0" :id="'actions-container-' + index.toString()">
                  <b-button v-show="tile_selected == index" variant="link" size="sm" title="Actions" squared
                    :id="'popover-target-' + index.toString()" class="float-right p-0">
                    <i class="fa fa-ellipsis-h text-primary"></i>
                  </b-button>
                </div>
                <b-popover :container="'actions-container-' + index.toString()"
                  :target="'popover-target-' + index.toString()" triggers="hover" placement="leftbottom">
                  <div>
                    <b-nav vertical>
                      <section v-for="(action, index) in defaultOptions.layout_grid[
                        index
                      ].options.actions" :key="index">
                        <b-nav-item v-if="!action.divider" :title="action.label"
                          @click.stop="invoke_action(action, index)">
                          <b-row class="px-2">
                            <b-col class="px-0">
                              <span class="text-normal">{{
                                action.label
                              }}</span>
                            </b-col>
                            <b-col cols="1">
                              <i :class="action.icon" class="text-primary"></i>
                            </b-col>
                          </b-row>
                        </b-nav-item>
                        <div class="divider" v-if="action.divider"></div>
                      </section>
                    </b-nav>
                  </div>
                </b-popover>
                <component :is="item.name" :tile="item" :refresh="refresh" @refreshed="refresh = false"></component>
              </b-card>
            </b-col>
          </b-row>
        </div>
        <div class="px-3 mt-3">
          <keep-alive>
            <component :is="selectedComponent" :search="search" :refresh="refresh" @refreshed="refresh = false"
              @discard="selectedComponent = null" />
          </keep-alive>
        </div>
      </b-card-body>
    </b-card>
    <TileAdd />
    <TileSettings v-if="tile_selected || tile_selected == 0" :tile="defaultOptions.layout_grid[tile_selected]
      ? defaultOptions.layout_grid[tile_selected]
      : { name: 'Empty Settings', settings: [] }
      " @apply="saveTile" @cancel="tile_settings = false" />
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

// import FileExplorer from "../Tiles/FileExplorer";
import NLPost from "../Tiles/NLPost";

// import SLPayments from "./Accounts/SLPayments";
// import BLPayments from "./Accounts/BLPayments";
import BookingForms from "./Accounts/BookingForms";
import InventoryLines from "./Charges/InventoryLines";
import AllCodes from "./Accounts/AllCodes";
import AllAccountsReports from "./Accounts/AllAccountsReports";
import NLCodes from "./Accounts/Setup/NLCodes";
import OpeningBalancesPG from "./Accounts/Setup/OpeningBalancesPG";
import OpeningBalances2 from "./Accounts/Setup/OpeningBalances2";
import OpeningBalances3 from "./Accounts/Setup/OpeningBalances3";
import InvoicingOnOff from "./Accounts/Setup/InvoicingOnOff";
import Periodend from "./Accounts/Periodend";

// import SLAutoInvoice from "./Accounts/SLAutoInvoice";
// import SLManualInvoice from "./Accounts/SLManualInvoice";
import SLStatements from "./Accounts/SLStatements";
import SLStatements2 from "./Accounts/SLStatements2";
import SLPayments from "./Accounts/SLPayments";
// import SLCreditNotes from "./Accounts/SLCreditNotes";
import Orders from "./Orders/Orders";

import SQLEdit from "./Systems/SQLEdit";
import Bankings from "./Accounts/Bankings";
// import BSPRecords from "./Accounts/BankAccounts/BSPRecords";
// import ConfermaCard from "./Accounts/BankAccounts/ConfermaCard";
// import JournalEntries from "./Accounts/JournalEntries";
import Journals from "./Accounts/Journals";

import Queue from "./Invoicing/Queue";
import FileManager from "./Systems/Filemanager";

import PNRLibrary from "./Pnrs/PNRLibrary";
import TicketsRepository from "./Tickets/TicketsRepository";
import Bookings from "./Bookings/Bookings";

import Clients from "./Setup/Setup_Clients";
import Events from "./Setup/Setup_Events";
import Suppliers from "./Setup/Setup_Suppliers";

import SLTransactions2 from "../Apps/Accounts/SLTransactions2";
import BLTransactions2 from "../Apps/Accounts/BLTransactions2";
import NLTransactions2 from "../Apps/Accounts/NLTransactions2";

import SLTransactionsN from "../Apps/Accounts/SLTransactionsN";
import BLTransactionsN from "../Apps/Accounts/BLTransactionsN";
import NLTransactionsN from "../Apps/Accounts/NLTransactionsN";

import WFH from "../Apps/Accounts/Setup/WFH";

export default {
  name: "DashboardAccounts",
  components: {
    NLPost,
    BookingForms,
    InventoryLines,
    Periodend,
    Orders,
    SLStatements,
    SLStatements2,
    SLPayments,
    TicketsRepository,
    SQLEdit,
    Bankings,
    Journals,
    NLCodes,
    InvoicingOnOff,
    OpeningBalancesPG,
    OpeningBalances2,
    OpeningBalances3,
    PNRLibrary,
    FileManager,
    Queue,
    Bookings,
    Clients,
    Suppliers,
    Events,
    SLTransactions2,
    BLTransactions2,
    NLTransactions2,
    SLTransactionsN,
    BLTransactionsN,
    NLTransactionsN,
    AllCodes,
    AllAccountsReports,
    WFH
  },
  async mounted() {
    await this.loadData()
  },
  async activated() {
    console.log("dashboard is activated");
  },
  deactivated() {
    console.log("dashboard is deactivated");
    clearInterval(this.timer_time);
    clearInterval(this.timer_refresh);
  },
  data() {
    return {
      title: "Accounts",
      icon: "fa fa-balance-scale",
      toolbar_variant: "outline-primary",
      busy: false,
      refresh: false,
      refresh_at: 0,
      refresh_time: new Date(),
      refresh_timeago: "",
      refresh_popover: false,
      layout_grid: [],
      layout_edit: false,
      tile_selected: null,
      tile_settings: false,
      timer_time: null,
      timer_refresh: null,
      defaultOptions: {
        layout_grid: [
          {
            moved: false,
            id: "0f5085d8-b594-40f0-8e0f-642042af2ee2",
            name: "BankingCards",
            cols: 12,
            md: 12,
            lg: 12,
            settings: [
              {
                key: "type",
                label: "Chart Type",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [{ value: "table", text: "Table" }],
                value: "table",
              },
              {
                key: "fileid",
                label: "File Id",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [{ value: "navitas_log", text: "navitas_log" }],
                value: "navitas_log",
              },
              {
                key: "title",
                label: "Title",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [
                  { value: true, text: "On" },
                  { value: false, text: "Off" },
                ],
                value: true,
                tab: "Annotate",
              },
              {
                key: "titletext",
                label: "Title Text",
                type: "text",
                value: "ETRPStatus",
                tab: "Annotate",
              },
              {
                key: "legend",
                label: "Legend",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [
                  { value: true, text: "On" },
                  { value: false, text: "Off" },
                ],
                value: false,
                tab: "Annotate",
              },
              {
                key: "legendposition",
                label: "Legend Position",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [
                  { value: "top", text: "Top" },
                  { value: "bottom", text: "Bottom" },
                  { value: "left", text: "Left" },
                  { value: "right", text: "Right" },
                ],
                value: "bottom",
                tab: "Annotate",
              },
              {
                key: "datalabels",
                label: "Data Labels",
                type: "radio-group",
                buttons: true,
                "button-variant": "outline-primary",
                values: [
                  { value: true, text: "On" },
                  { value: false, text: "Off" },
                ],
                value: false,
                tab: "Annotate",
              },

              {
                key: "titlefontnamesize",
                label: "",
                label_type: "Font Type",
                label_size: "Font Size",
                type: "fontsize",
                values_type: [
                  { value: "Arial", text: "Arial" },
                  { value: "Helvetica Neue", text: "Helvetica Neue" },
                ],
                values_size: [
                  { value: "10", text: "10" },
                  { value: "12", text: "12" },
                  { value: "14", text: "14" },
                ],
                tab: "Fonts",
              },
            ],
            options: {
              actions: [
                {
                  key: "settings",
                  label: "Settings",
                  icon: "fa fa fa-cog text-primary",
                },
                { divider: true },
                { key: "small", label: "Small", icon: "fa fa-th text-primary" },
                {
                  key: "large",
                  label: "Large",
                  icon: "fa fa-square text-primary",
                },
                { divider: true },
                {
                  key: "delete",
                  label: "Delete",
                  icon: "fa fa-trash text-danger",
                },
              ],
            },
          },
        ],
      },
      reponsiveGrid: {
        layouts: {
          md: [
            { x: 0, y: 0, w: 5, h: 6, i: "1" },
            { x: 5, y: 0, w: 5, h: 6, i: "2" },
            // { x: 0, y: 25, w: 5, h: 6, i: "3" },
            // { x: 5, y: 25, w: 3, h: 6, i: "4" },
          ],
        },
        breakpoint: "md",
        components: {
          1: { i: "1", component: "NLPost", defaultSize: 2 },
        },
        cols: 10,
        breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
        colsAll: { lg: 10, md: 8, sm: 6, xs: 4, xxs: 2 },
        isDraggable: true,
        isResizable: true,
      },
      selectedComponent: null,
      search: {},
    };
  },
  watch: {
    refresh: {
      // immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.refresh_time = new Date();
        }
      },
    },
  },
  computed: {
    ...mapGetters(["window", "user"]),
  },
  methods: {
    async loadData() {
      console.log("loadData");
      this.busy = true;

      // OVERIDE THE DATA
      this.layout_grid = this.defaultOptions.layout_grid;
      this.busy = false;
      // this.layout_autorefresh();
    },
    async saveData() {
      console.log("saveData", this.layout);
      this.busy = true;

      this.busy = false;
      this.layout_edit = false;
    },
    async saveTile(t) {
      console.log("saveTile", this.tile_selected, t);
      this.layout_grid[this.tile_selected] = t;
      this.refresh = true;
      this.tile_settings = false;
    },
    invoke_action(s, r) {
      console.log("invoke action", s, r);
      if (s.key) {
        console.log(s.key);
        switch (s.key) {
          case "settings":
            this.tile_settings = true;
            this.$root.$emit("bv::toggle::collapse", "tilesettings");
            break;
        }
      }
    },
    async layout_refresh() {
      await this.loadData();
      this.refresh = true;
    },
    layout_autorefresh() {
      this.refresh_time = new Date();
      clearInterval(this.timer_time);
      clearInterval(this.timer_refresh);
      if (this.refresh_at > 0) {
        this.timer_refresh = setInterval(() => {
          this.layout_autorefresh();
        }, 1000000);
        if (this.refresh_at > 0) {
          this.timer_time = setInterval(() => {
            this.layout_timeago();
          }, 1000000);
        }
        this.layout_timeago();
      }
      console.log("layout_autorefresh");
    },
    layout_timeago() {
      this.refresh_timeago = this.$options.filters.formatTimeago(
        this.refresh_time
      );
      console.log("layout_timeago");
    },
    runreport(e, c) {
      console.log("run", e);
      if (c) {
        this.selectedComponent = c;
      } else {
        this.selectedComponent = "Report";
      }
      this.search = {
        name: e.label,
        call: e.id,
      };
    },
  },
};
</script>

<style></style>
